/**
 * ThankYouHero — Weidner Via6 page hero for /thank-you.
 * See `FloorPlansHero.tsx` and `_PageImageHeroBody.tsx` for the shared
 * pattern. Owns its slot registration, contentSchema, and hidden
 * literal-path anchors; visual rendering is delegated to the body.
 */

import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { RichTextContent, EditableSlotGroup } from '@vibesites/runtime/react';
import { PageImageHeroBody } from './_PageImageHeroBody';

const bgDef = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Thank you hero image',
    },
  },
  sourceBinding: {
    collection: 'photo_gallery',
    defaultIndex: 0,
    fieldMappings: { image: 'image', alt: 'alt_text' },
  },
};

export function ThankYouHero() {
  return (
    <>
      <PageImageHeroBody
        titlePath="thankyouhero.title"
        bgPath="thankyouhero.bg_image"
        bgDef={bgDef}
        defaultTitle="Thank You"
        keywords={['lifestyle', 'residents']}
        pageHint="thankyouhero"
        altText="Thank you hero image"
      />

      <RichTextContent
        path="thankyouhero.title"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      />
      <EditableSlotGroup
        groupPath="thankyouhero.bg_image"
        definition={bgDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ThankYouHero',
  displayName: 'Thank You Hero',
  tokens: {
    'thankyouhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: 'Thank You',
    },
  },
  slotGroups: {
    'thankyouhero.bg_image': {
      label: 'Background Image',
      fields: {
        image: {
          label: 'Image',
          type: 'image',
          defaultField: 'property_featured_image',
        },
        alt: {
          label: 'Alt Text',
          type: 'text',
          defaultValue: 'Thank you hero image',
        },
      },
      sourceBinding: {
        collection: 'photo_gallery',
        defaultIndex: 0,
        fieldMappings: { image: 'image', alt: 'alt_text' },
      },
    },
  },
};

(ThankYouHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ThankYouHero;
